import * as React from "react";
function SvgArobase(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M31.49 14.13a14.72 14.72 0 01-.87 5.06 8.16 8.16 0 01-2.4 3.53A5.77 5.77 0 0124.63 24a4.24 4.24 0 01-2.8-1 4 4 0 01-1.33-2.6h-.13A6 6 0 0114.7 24a5.57 5.57 0 01-4.53-2 8.65 8.65 0 01-1.67-5.4 9.27 9.27 0 012.27-6.46 7.8 7.8 0 016-2.47 15.21 15.21 0 013 .27 16.15 16.15 0 013 .67l-.47 9.13v.4c0 2.33.87 3.47 2.6 3.47a3.26 3.26 0 002.87-2.07 10.86 10.86 0 001.2-5.4A13 13 0 0027.5 8a10 10 0 00-4.07-4.07 12.12 12.12 0 00-6.06-1.4A14.43 14.43 0 009.7 4.27 11.68 11.68 0 004.84 9.4a16.35 16.35 0 00-1.67 7.73c0 4 1.07 7 3.13 9.13s5.06 3.13 9 3.2a24.22 24.22 0 008.46-1.67v2.6A20.37 20.37 0 0115.3 32c-4.67 0-8.3-1.27-10.93-3.87S.5 21.93.5 17.27a18.73 18.73 0 012.07-8.93 14.39 14.39 0 016-6.13A17.6 17.6 0 0117.37 0a15 15 0 017.4 1.73 12 12 0 015 5 15.7 15.7 0 011.72 7.4zm-20.06 2.54q0 5 3.8 5c2.67 0 4.13-2 4.4-6.06l.27-5.06a11.72 11.72 0 00-3.07-.4 5.07 5.07 0 00-4 1.73 7.27 7.27 0 00-1.4 4.79z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArobase);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
